import { useMemo } from 'react';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useCanSendEmailCampaignQuery } from 'shared/types/graphql';

export type useEmailCampaignsReturnType = {
  canSendEmailCampaigns: boolean;
};

export const useEmailCampaigns = (): useEmailCampaignsReturnType => {
  const { currentClinicId: clinicId } = useClinicUser();

  const { data: canSendEmailCampaignsData } = useCanSendEmailCampaignQuery({
    variables: {
      clinicId: clinicId || '',
    },
    skip: !clinicId,
  });

  const canSendEmailCampaigns = useMemo(
    () => !!canSendEmailCampaignsData?.canSendEmailCampaign,
    [canSendEmailCampaignsData?.canSendEmailCampaign],
  );

  return {
    canSendEmailCampaigns,
  };
};

export default useEmailCampaigns;
